import React, { FC } from 'react'

interface VideoSoundOnIconProps {
  width?: number
  height?: number
  className?: string
}

const VideoSoundOnIcon: FC<VideoSoundOnIconProps> = ({
  width = 32,
  height = 32,
  className = '',
}) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 32 32"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <g clipPath="url(#clip0_96_3986)">
        {/* Background circle */}
        <rect
          width="32"
          height="32"
          rx="16"
          transform="matrix(1 0 0 -1 0 32)"
          fill="black"
          fillOpacity="0.4"
        />
        {/* Speaker path */}
        <path
          d="M21.6632 22.4727V11.7934C21.6632 11.0624 21.1362 10.4378 20.4155 10.3148L13.4155 9.12031C12.4995 8.964 11.6632 9.66968 11.6632 10.5989V20.7662"
          stroke="white"
          strokeWidth="1.2"
          strokeLinejoin="round"
        />
        {/* Sound wave ellipses */}
        <ellipse
          cx="10.0172"
          cy="20.9729"
          rx="2.23944"
          ry="1.70482"
          fill="white"
        />
        <ellipse
          cx="20.0211"
          cy="22.4729"
          rx="2.23944"
          ry="1.70482"
          fill="white"
        />
      </g>
      <defs>
        <clipPath id="clip0_96_3986">
          <rect width="32" height="32" fill="white" />
        </clipPath>
      </defs>
    </svg>
  )
}

export default VideoSoundOnIcon
